(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('header.site-header');
    const videoSection = document.querySelector('.video-slideshow'); // replace with your video section class
    if (!videoSection) return;

    // function to toggle sticky
    const toggleHeader = () => {
      const videoBottom = videoSection.offsetTop + videoSection.offsetHeight;
      if (window.scrollY > videoBottom) {
        header.classList.add('sticky');
      } else {
        header.classList.remove('sticky');
      }
    }

    // run on scroll + resize + load
    window.addEventListener('scroll', toggleHeader);
    window.addEventListener('resize', toggleHeader);
    toggleHeader();
  });

  } catch(e) { console.error(e); }
})();
})();
